interface IGUIItemProps {
  size: number,
  items: number | null,
  s: number[],
  t: number[],
  isEditMode?: boolean,
  onClick:()=>void,
  onMouseEnter:()=>void
  onMouseLeave:()=>void
}

export default class CommonSVGStore {

  public static getClose(): JSX.Element {
    return (
      <svg fill="none" viewBox="0 0 12 12" className="w-2.5 h-2.5 shrink-0" aria-hidden="true">
        <path fill="currentColor" fill-rule="evenodd" d="M11.694 11.693a1.046 1.046 0 0 1-1.48 0L6 7.478l-4.215 4.215a1.046 1.046 0 1 1-1.479-1.48L4.521 6 .307 1.785A1.046 1.046 0 1 1 1.787.306L6 4.52 10.214.306a1.046 1.046 0 1 1 1.479 1.48L7.479 5.998l4.215 4.215c.408.408.408 1.07 0 1.479" clip-rule="evenodd">
        </path>
      </svg>
    )
  }


  public static getPlay({ size = 30, s = [1, 1], t = [0, 0], 
    onClick=()=>{},
    onMouseEnter=()=>{},
    onMouseLeave=()=>{} 
  }: Partial<IGUIItemProps> = {}): JSX.Element {
    let transform = "scale(" + s[0] + "," + s[1] + ") translate(" + t[0] + "," + t[1] + ")"
    let transformButton = "scale(0.75,0.75) translate(13,10)"
    const r = 0.55 * size;

    return (
      <svg
        onClick={(e)=>{onClick()}}
        onMouseEnter={(e)=>{onMouseEnter()}}
        onMouseLeave={(e)=>{onMouseLeave()}}
        width={size}
        height={size}
        viewBox="0 0 32 32">,
        <g transform={transform}>
          <circle cx={"50%"} cy={"50%"} r={"50%"} fill="#ffffff" />
          <g
            transform={transformButton}
          >
            <path fill="#000000" d="M19.173 10.407a1.406 1.406 0 0 1 0 2.436L2.298 22.586a1.406 1.406 0 0 1-2.11-1.218V1.882A1.406 1.406 0 0 1 2.298.664z" />
          </g>
        </g>
      </svg>
    )
  }
}